import React from 'react';
import { FaMoneyBillWave } from 'react-icons/fa';

const placeholder = require('../placeholder.png');

const Pay = () => {
  return (
    <div>
      <FaMoneyBillWave className="mx-auto text-3xl text-[#974D9B]" />
      <p className="mt-3 font-2xl text-slate-600">
        Effortlessly manage all your bills and payments
      </p>
      <img src={placeholder} alt="" className="w-[60%] mx-auto mt-5" />
    </div>
  );
};

export default Pay;
